<template lang="pug">
.user-team-full-select-card
  .user-team-full-select-card__title
    p Название
    p Капитан

  .user-team-full-select-card__value
    p.ajax__line.-round-(:style="randomSizeStyle()")
    p.ajax__line.-round-(:style="randomSizeStyle()")


</template>

<script>
export default {
  data: () => ({
    ajaxStyle: {
      height: '1em',
      width: '100px'
    }
  }),
  methods: {
    // Приколюха :)
    randomSizeStyle() {
      const max = 145;
      const min = 70;
      const width = ~~(Math.random() * (max - min) + min);
      return {
        height: '1em',
        width: `${width}px`
      };
    }
  }
};
</script>
